<!--动态图对象 右键属性-->
<template>
  <div>
    <gs-modal v-loading="loading" v-model="visible" :before-close="beforeClose" :before-confirm="beforeConfirm"
      :title="isEdit ? name + '-趋势日志' : '新建' + '-趋势日志'" :has-form="true" class="time-event-dialog-modal" @close="close"
      @confirm="handleConfirm">
      <gs-tabs v-model="activeName" type="content-tab">
        <gs-tab-pane label="常规" name="first">
          <gs-form :model="form" label-width="50px" label-position="left" gap="small">
            <gs-form-item label="名称" prop="target" class="form-item-radio">
              <gs-input ref="nameInput" v-model="name" />
            </gs-form-item>
            <gs-form-item label="描述" prop="target" class="form-item-radio">
              <gs-input v-model="description" />
            </gs-form-item>

            <div class="fifty-width-box">
              <el-row>
                <el-col :span='9' :offset="5">
                  <div style="margin-left:5px">
                    <!--  <span style='color:#9e9d9d'>创建：</span><span style='color:#9e9d9d'>{{username}}</span> -->
                  </div>
                </el-col>
                <el-col :span='9' :offset="1">
                  <div style="margin-left:15px">
                    <!--  <span style='color:#9e9d9d'>时间：2021/9/12/13:21</span> -->
                  </div>
                </el-col>
              </el-row>
            </div>
          </gs-form>
        </gs-tab-pane>
        <gs-tab-pane label="数据" name="second">
          <div class="top-form-right">
            <gs-form label-width="100px" label-position="left" gap="small">
            </gs-form>
          </div>
          <div>
            <span style="color: #ff8706;cursor: pointer" @click="add">添加对象</span>
            <div class="form-item-objectSeries">

              <el-table :data="form.objectSeries" size="mini"
                :header-cell-style="{ background: '#343434', color: '#c7c7c9', border: '1px solid #4e4c4c' }"
                style="width: 100%;height: 290px;">
                <el-table-column prop="name" label="名称" align="center" width="150">
                </el-table-column>
                <el-table-column prop="type" label="类型" align="center" width="150">
                </el-table-column>
                <el-table-column label="操作" align="center">
                  <template slot-scope="scope">
                    <i class="el-icon-delete" @click="del(scope.row)"></i>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </gs-tab-pane>
        <gs-tab-pane label="采样" name="third" v-if="thirdShow">

          <!--  <gs-form-item
              label="开始时间"
              prop="startTime"
            >
              <gs-date-picker
                v-model="startTime"
                :default-time="defaultTime"
                type="date-time"
              />
            </gs-form-item>
            <gs-form-item
              label="结束时间"
              prop="stopTime"
            >
              <gs-date-picker
                v-model="stopTime"
                :default-time="defaultTime"
                type="date-time"
              />
            </gs-form-item> -->

          <div class='inp-intervalue'>
            <div style=" width:100px;">采样间隔</div>
            <div style=" width:150px;">
              <gs-select v-model="form.logInterval_value">
                <gs-option v-for="item in timeArray" :key="item.value" :label="item.label" :value="item.value">
                </gs-option>
              </gs-select>
            </div>
          </div>

        </gs-tab-pane>

      </gs-tabs>
      <span slot="footer" class="dialog-footer">
        <gs-button type="primary" size="mini" @click="handleConfirm">确 定</gs-button>
        <gs-button type="primary" size="mini" @click="beforeClose">取 消</gs-button>
        <gs-button type="primary" size="mini">帮 助</gs-button>
      </span>
    </gs-modal>
    <gs-modal v-model="visibleAdd" :before-close="beforeCloseAdd" class="my-test-class" title="添加" @close="closeAdd"
      @confirm="handleConfirmAdd">
      <div style="width: 100%;height: 500px;">
        <gs-tree v-if="visibleAdd" ref="tree" :data="addList" :props="props" :disable-node="true"
          :leaf-checkbox-only="true" :node-key="'id'" show-checkbox @check-change="checkEvent" />
      </div>
    </gs-modal>
    <gs-modal v-model="visibleProperties" :before-close="beforeCloseProperties" class="my-test-class" title="属性"
      @close="closeProperties" @confirm="handleConfirmProperties">
      <gs-select />
    </gs-modal>
    <gs-modal title="帮助" v-model="dialogHelp" class="my-test-class" width="42%">
      <span class="tab">常规</span><br>
      <hr />
      <span class="tit">名称：</span><span class="txt">趋势日志对象的名称</span><br>
      <span class="tit">描述：</span><span class="txt">该对的详细描述</span><br>
      <span class="tit">显示个数：</span><span class="txt">显示趋势日志值的数量</span><br>
      <span class="tit">清除日志：</span><span class="txt">单击清空日志</span><br>
      <span class="tit">信息-状态：</span><span class="txt">默认选中***采样***中指定的状态</span><br>
      <span class="tab">数据源</span><br>
      <hr />
      <span class="tit">开始时间：</span><span class="txt">指定开始记录的时间,请不要已经过去的时间!</span><br>
      <span class="tit">对象列表：</span><span class="txt">添加要记录趋势的点位</span><br>
      <span class="tab">采样</span><br>
      <hr />
      <span class="tit">启动选项：</span><span class="txt">可选手动开启,手动关闭,自动</span><br>
      <span class="tit">手动关闭：</span><span class="txt">不进行记录</span><br>
      <span class="tit">手动开启：</span><span class="txt">日志记录立即开始.日志根据定义的开始时间进行同步.如果未输入开始时间,则从单击确定按钮的那一刻起计算开始时间</span><br>
      <span class="tit">自动：</span><span
        class="txt">当超过开始时间并且通过事件对象(状态更改,时间事件或时间事件列表)进行激活是,记录开始日志对象处于活动状态是,它以事件对象控制的定义间隔进行日志记录.如果未输入事件对象,则在经过输入的开始时间后开始记录.如果为输入开始时间,则从单击确定按钮的那一刻起计算开始时间.</span><br>
      <span class="tit">循环日志：</span><span class="txt">​如果希望循环存储记录值,请选中该复选框.也就是说,当可用日志空间已满时,第一个(最旧的)那个值将被覆盖.</span><br>
      <span class="tit">采样间隔：</span><span class="txt">输入两次记录之间所需的时间.并选择时间单位,可选秒,分,时,天</span><br>
      <span class="tit">日志空间：</span><span
        class="txt">​输入要记录多长时间的记录,并选择时间单位,可选秒,分,时,天.如果日志记录不是循环的,那么此时间过去后,日志空间已满.将不再进行存储,如果日志记录是循环的,则此时间等于循环间隔.</span><br>
      </span>
    </gs-modal>
  </div>
</template>

<script type="text/ecmascript-6">
import { mapState, mapMutations } from 'vuex'
import service from '../../service/leftService.js'
import moment from 'moment'
import eventBus from '../timeChart/vue.js'
export default {
  components: {

  },
  data() {
    return {
      timeArray: [
        {
          value: '5',
          label: '5分钟'
        }, {
          value: '10',
          label: '10分钟'
        },
        {
          value: '15',
          label: '15分钟'
        },
        {
          value: '30',
          label: '30分钟'
        }, {
          value: '45',
          label: '45分钟'
        }, {
          value: '60',
          label: '60分钟'
        },
      ],
      creatTime: '',
      creatUser: localStorage.getItem('username'),
      username: localStorage.getItem('username'),
      dialogHelp: false,
      min: 10,
      checkedLog: true,
      optionSpan: 'Auto',
      logSpace_unit: 'h',
      logSpace_value: 1,
      trendNum: 1,
      startTime: moment(),
      stopTime: moment(),
      defaultTime: moment(),
      objectInfo: {},
      loading: false,
      activeName: 'first',
      form: {
        parentId: '',
        objectSeries: [],
        primaryY_autoScale: true,
        primaryY_Mininum: 0,
        primaryY_maximum: 100,
        secondaryY_autoScale: true,
        secondaryY_Mininum: 0,
        secondaryY_maximum: 100,
        logInterval_value: 5,
        logInterval_unit: 'm',
        logInterval_active: 'Auto',
        logSpace_value: 1,
        logSpace_unit: 'm',
        startTime: moment(),
        stopTime: moment(),
        // maxLogNum: ''
      },
      description: '',
      checked: '',
      options: [
        {
          label: '分(m)',
          value: 'm'
        }
      ],
      active: [
        {
          label: '关闭',
          value: 'Man-Off'
        }, {
          label: '打开',
          value: 'Man-On'
        }, {
          label: '自动',
          value: 'Auto'
        }
      ],
      visibleAdd: false,
      visibleProperties: false,
      addList: [],
      props: {
        label: 'name',
        disabled: 'type:folder'
      },
      selectList: [],
      name: '',
      showList: [],
      row: '',
      isEdit: false,
      oldData: {},
      corn: {},
      thirdShow: false,
    }
  },
  computed: {
    ...mapState({
      visible: 'trendJournalShow',
      nodeData: 'objectInfo'
    })
  },
  watch: {
    tableData() {
      this.form.objList = this.tableData
    },
    nodeData() {

    },
    visible() {
      if (this.visible) {
        this.thirdShow = true
        this.objectInfo = JSON.parse(JSON.stringify(this.nodeData))
        setTimeout(() => {
          this.$refs.nameInput.focus()
        }, 100)
        if (JSON.stringify(this.objectInfo) !== '{}' && this.objectInfo.type === 'trendLog') {
          this.startTime = moment(this.objectInfo.attribute.formData.startTime)
          this.stopTime = moment(this.objectInfo.attribute.formData.stopTime)
          this.isEdit = true
          this.activeName = 'first'
          this.form = this.objectInfo.attribute.formData ? this.objectInfo.attribute.formData : {}
          this.description = this.objectInfo.description ? this.objectInfo.description : ''
          this.name = this.objectInfo.name ? this.objectInfo.name : ''
          this.form.objectSeries = this.objectInfo.attribute.dataMap ? JSON.parse(JSON.stringify(this.objectInfo.attribute.dataMap)) : []
        } else {
          this.isEdit = false
          this.activeName = 'first'
          this.form = {
            dataMap: '',
            objectSeries: [],
            primaryY_autoScale: true,
            primaryY_Mininum: 0,
            primaryY_maximum: 100,
            secondaryY_autoScale: true,
            secondaryY_Mininum: 0,
            secondaryY_maximum: 100,
            logInterval_value: this.form.logInterval_value,
            logInterval_unit: 'm',
            // maxLogNum: ''
          }
          this.description = ''
          this.name = ''
        }
      }
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    ...mapMutations({
      close: 'TREND_JOURNAL_HIDE',
      needReload: 'TREND_JOURNAL_TREE'
    }),
    clearLog() {
      let id = this.nodeData.id
      service.DeleteTrendLog(id).then(res => {
        this.$Message.success("删除成功")
      }).catch(err => {
        console.info(err)
      })
    },
    caiyangChange() {
      if (this.form.logInterval_unit != 's') {
        //this.form.logInterval_value = 1
        //this.min = 1
      } else {
        // this.form.logInterval_value = 10
        // this.min = 10
      }
    },
    handleChange() {
      if (this.form.logInterval_unit != 's') {
        //  this.form.logInterval_value = 1
        // this.min = 1
      } else {
        // this.form.logInterval_value = 10
        //  this.min = 10
      }
    },
    optionStart() {
      this.optionSpan = this.form.logInterval_active
    },
    beforeClose() {
      this.close()
      this.thirdShow = false
    },
    handleCloseHelp() {
      this.dialogHelp = false
    },
    // cancel () {
    //   this.nodeData = this.oldData
    //   this.close()
    // },
    beforeConfirm(e, done) {
      if (this.name === null || this.name === '') {
        this.$Message.warning('名称不能为空!')
        return
      }
      if (!this.form.primaryY_autoScale) {
        if (this.form.primaryY_Mininum >= this.form.primaryY_maximum) {
          this.$Message.warning('Y轴最小值必须小于最大值')
          return
        }
      }
      if (!this.form.secondaryY_autoScale) {
        if (this.form.secondaryY_Mininum >= this.form.secondaryY_maximum) {
          this.$Message.warning('Y轴最小值必须小于最大值')
          return
        }
      }
      // done(false)可以阻止modal关闭
      done()
    },
    handleConfirm() {
      let _this = this
      this.loading = true
      let arr = []
      let backArr = JSON.parse(JSON.stringify(this.form.objectSeries))
      this.form.objectSeries.forEach(e => {
        arr.push(e.id)
      })
      this.form.objectSeries = arr
      // 生成cron表达式
      if (this.form.logInterval_unit === 's') {
        let cornTit = '0' + '/' + this.form.logInterval_value + ' * * * * ?'
        this.corn[cornTit] = arr
      } if (this.form.logInterval_unit === 'm') {
        let cornTit = '0' + ' 0/' + this.form.logInterval_value + ' * * * ?'
        this.corn[cornTit] = arr
      }
      if (this.form.logInterval_unit === 'h') {
        let cornTit = '0' + ' 0' + ' 0/' + this.form.logInterval_value + ' * * ?'
        this.corn[cornTit] = arr
      }
      this.form.startTime = this.startTime
      this.form.stopTime = this.stopTime
      if (this.objectInfo.id && this.objectInfo.type === 'trendLog') {
        let param = {
          id: this.objectInfo.id,
          name: this.name,
          type: 'trendLog',
          parentId: this.objectInfo.parentId,
          description: this.description,
          "value": null,
          "timeStamp": 1575857454,
          creator: localStorage.getItem('username'),
          attribute: {
            dataMap: this.form.dataMap,
            formData: this.form,
            startTime: this.startTime.valueOf(),
            stopTime: moment().add(12, "months").valueOf(),
            jobName: 2,
            jobGroupName: this.objectInfo.name,
            cron: this.corn,
            showTrendLogValues: this.trendNum,
          } // this.form // 其他信息这里，键值对形式
        }
        service.renamePoint(param).then(res => {
          this.loading = false
          this.$Message.success('修改成功')
          _this.objectInfo.attribute.objectSeries = backArr
          this.close()
          this.objectInfo.name = this.name
          res.attribute.objectSeries = backArr
          this.$store.state.tabPanel = res
          this.$store.state.updateTreeNode = res
          this.description = ''
          this.name = ''
          // this.form = {
          //   objectSeries: []
          // }
          this.showList = []
          // eventBus.$emit('changeInterval', res)
        }).catch(err => {
          this.loading = false
          this.form.objectSeries = backArr
          this.$Message.error(err.message)
        })
      } else {
        let param = {
          name: this.name,
          type: 'trendLog',
          parentId: this.objectInfo.id,
          description: this.description,
          "value": null,
          "timeStamp": 1575857454,
          /*   creator:localStorage.getItem('username'), */
          attribute: {
            dataMap: this.form.dataMap,
            formData: this.form,
            jobName: 2,
            jobGroupName: this.objectInfo.name,
            cron: this.corn,
            showTrendLogValues: this.trendNum,
            startTime: this.startTime.valueOf(),
            stopTime: moment().add(12, "months").valueOf(),
          }
        }
        service.newAddPoint(param).then(res => {
          this.thirdShow = false
          this.loading = false
          this.$Message.success('添加成功')
          setTimeout(() => {
            res.attribute.objectSeries = backArr
            _this.$store.state.addTreeNode = res
          }, 0)
          this.close()
          this.description = ''
          this.name = ''
          // this.form = {
          //   objectSeries: []
          // }
          this.showList = []
          this.corn = {}
        }).catch(err => {
          this.loading = false
          this.form.objectSeries = backArr
          this.$Message.error(err.message)
        })
      }
    },
    onChange(v) {

    },
    add() {
      let _this = this
      this.visibleAdd = true
      if (this.nodeData.type == "server" || this.nodeData.type == "project") {
        service.getAllTree().then(res => {
          _this.addList = res
        })
      } else if (this.nodeData.type == "logicalGroup") {
        service.getTree('', this.nodeData.id).then(res => {
          res[0].children.forEach(item => {
            service.getTree('Point', item.id).then(restree => {
              item.children = restree[0].children
            })
          })
          setTimeout(() => {
            _this.addList = res
          }, 2000)

        })
      } else {
        service.getTree('Point', this.nodeData.id).then(res => {
          this.addList = res
          if (_this.form.objectSeries !== null && _this.form.objectSeries.length > 0) {
            setTimeout(() => {
              _this.form.objectSeries.forEach(res => {
                _this.$refs.tree.setChecked(res.id, true)
              })
            }, 0)
          }
        })
      }

    },
    del(val) {
      this.form.objectSeries.forEach((value, index, array) => {
        if (val.name === value.name) {
          this.form.objectSeries.splice(index, 1);
        }
      });
      if (this.form.objectSeries.length === 0) {
        this.thirdShow = false
      }
      /*  if (this.selectList === null || this.selectList.length === 0) {
         this.$Message.warning('请至少选择一项')
         return
       } */
      /* this.selectList.forEach((value, index, array) => {
        this.form.objectSeries = this.form.objectSeries.filter(e => {
          return e.id !== value.id
        })
      }) */
    },
    yAxis() {

    },
    property() {
      if (this.selectList.length !== 1) {
        this.$Message.warning('只能勾选一项')
        return
      }
      this.visibleProperties = true
    },
    beforeCloseAdd() {
      this.visibleAdd = false
    },
    closeAdd() {
      this.visibleAdd = false
    },
    handleConfirmAdd() {
      this.thirdShow = true
      let _this = this
      this.$refs.tree.getCheckedNodes(true).forEach(e => {
        _this.form.objectSeries.push(e.data)
      })
      this.form.objectSeries = this.unique(this.form.objectSeries, 'id')
      this.form.dataMap = this.unique(this.form.objectSeries, 'id')
      this.visibleAdd = false
    },
    unique(arr, name) {
      var hash = {}
      return arr.reduce(function (item, next) {
        hash[next[name]] ? '' : hash[next[name]] = true && item.push(next)
        return item
      }, [])
    },
    beforeCloseProperties() {
      this.visibleProperties = false
    },
    closeProperties() {
      this.visibleProperties = false
    },
    handleConfirmProperties() {
      this.visibleProperties = false
    },
    checkEvent(node, isSelect, halfSelect) {
      //   value_Analog,
      // value_Multistate,
      // value_Binary,
      // value_String,
      // BinaryInput,
      // BinaryOutput,
      // AnalogInput,
      // AnalogOutput
      /* switch (node.type) {
        case 'value_Analog':
          //this.singleChoice(node.id)
          break
        case 'value_Multistate':
        //  this.singleChoice(node.id)
          break
        case 'value_Binary':
         // this.singleChoice(node.id)
          break
        case 'value_String':
        //  this.singleChoice(node.id)
          break
        case 'BinaryInput':
         // this.singleChoice(node.id)
          break
        case 'BinaryOutput':
         // this.singleChoice(node.id)
          break
        case 'AnalogInput':
          //this.singleChoice(node.id)
          break
        case 'AnalogOutput':
         // this.singleChoice(node.id)
          break
        case 'AnalogInputR':
         // this.singleChoice(node.id)
          break
        case 'BinaryOutputR':
         // this.singleChoice(node.id)
          break
        case 'AnalogOutputW':
         // this.singleChoice(node.id)
          break
        case 'AnalogOutputR':
         // this.singleChoice(node.id)
          break
        case 'IntegerW':
          break
        default:
          this.$Message.error('此节点为目录，无法被选择')
          this.$refs.tree.setChecked(node.id, false)
          break
      } */
    },
    selectData(selection, row) {
      this.selectList = selection
    },
    // 单选操作
    singleChoice(id) {
      let leafCheckArr = this.$refs.tree.getCheckedKeys()
      if (leafCheckArr.length > 1) {
        leafCheckArr.forEach(item => {
          if (item != id) {
            this.$refs.tree.setChecked(item, false)
          }
        })
      }
    }
  }
}
</script>
<style scoped>
.inp-intervalue {
  display: flex;
  align-items: center;
  justify-content: left;
}

.inp-intervalue /deep/ .gs-input-inner {
  padding-left: 23px;
}

.fifty-width-box {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  /* Firefox */
  -webkit-box-sizing: border-box;
  /* Safari */
  width: 100%;
  float: left;
  margin-right: 13px;
}

fieldset {
  padding: 12px;
  border-radius: 5px;
  border: solid 2px #d9d9d9;
}

.bottom-btn {
  margin: 20px;
  text-align: center;
}

.form-item-objectSeries {
  height: 320px;
  overflow: auto;
  margin-bottom: 12px;
  padding: 12px;
  border: solid 1px #d9d9d9;
  border-radius: 1px;
}

.tab {
  font-size: 16px;
  font-weight: 800;
}

.tit {
  font-size: 14px;
  font-weight: 800;
  color: #5d5d5d;
}

.txt {
  font-size: 14px;
  color: #5d5d5d;
}
</style>



// WEBPACK FOOTER //
// src/components/trendJournal/trendjournal.vue